var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderListItem } from '../../hooks/useListItem';
import Select from '../atoms/SelectField';
var PaymentTimingFilter = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, label = _a.label;
    var t = useTranslation().t;
    var paymentTimingFilterItems = useOrderListItem().paymentTimingFilterItems;
    var handleChange = React.useCallback(function (event) {
        var value = event.target.value;
        onFilterChanged(columnDef.tableData.id, value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement(Select, { fullWidth: true, margin: "none", variant: "standard", value: columnDef.tableData.filterValue || null, onChange: handleChange, label: label || '', items: __spreadArray([
            { text: t('labels.all'), value: '' }
        ], paymentTimingFilterItems, true) }));
};
export default PaymentTimingFilter;
